module.exports = __webpack_public_path__ + "static/media/sparkle.d4eb13d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/sparkle.png
// module id = 241
// module chunks = 0